// Vertical range shared by the level history chart and the sparklines, so both draw the same picture:
// the flows, every flow level, and always a bit of the low and high zones around the recommended range,
// even when the flows stay far from it.
export function getFlowAxisRange(flows = [], { min, max, levelFlows = [] } = {}) {
  const hasRange = Number.isFinite(min) && Number.isFinite(max) && max > min;
  const zoneMargin = hasRange ? (max - min) * 0.2 : 0;
  const values = [...flows, ...levelFlows, ...(hasRange ? [min - zoneMargin, max + zoneMargin] : [])].filter(
    Number.isFinite,
  );
  const lowest = values.length ? Math.min(...values) : 0;
  const highest = values.length ? Math.max(...values) : 1;
  const padding = (highest - lowest) * 0.04 || 1;
  return { min: Math.max(0, lowest - padding), max: highest + padding };
}
